import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useContent } from "@/context/ContentContext";

export function CTASection({ title, subtitle, buttonLabel, buttonTo }) {
  const { settings } = useContent();
  const b = settings?.buttons || {};
  const ctaTitle = title || b.cta_title || "Ready to build meaningful change?";
  const ctaSubtitle = subtitle || b.cta_subtitle || "Book your consultation today and take the first step toward lasting, people-centered progress.";
  const ctaLabel = buttonLabel || b.cta_button_label || "Book a Consultation";
  const ctaTo = buttonTo || b.cta_button_link || "/book";
  return (
    <section className="container-site py-20 sm:py-28" data-testid="cta-section">
      <Reveal>
        <div className="grain-overlay relative overflow-hidden rounded-3xl bg-forest px-8 py-16 sm:px-16 sm:py-20 dark:bg-forest-800">
          <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-sage/20 blur-2xl" />
          <div className="pointer-events-none absolute -bottom-32 -left-16 h-80 w-80 rounded-full bg-terracotta-500/15 blur-2xl" />
          <div className="relative max-w-2xl">
            <h2 className="font-heading text-3xl font-semibold tracking-tight text-cream sm:text-4xl lg:text-5xl">
              {ctaTitle}
            </h2>
            <p className="mt-5 text-base leading-relaxed text-cream/75 md:text-lg">{ctaSubtitle}</p>
            <div className="mt-9 flex flex-wrap gap-4">
              <Link
                to={ctaTo}
                data-testid="cta-book-button"
                className="inline-flex items-center gap-2 rounded-full bg-terracotta-500 px-7 py-3.5 text-sm font-medium text-cream transition-colors duration-300 hover:bg-cream hover:text-forest"
              >
                {ctaLabel}
                <ArrowRight className="h-4 w-4" />
              </Link>
              <Link
                to="/contact"
                data-testid="cta-contact-link"
                className="inline-flex items-center gap-2 rounded-full border border-cream/30 px-7 py-3.5 text-sm font-medium text-cream transition-colors duration-300 hover:border-terracotta-400 hover:text-terracotta-400"
              >
                Ask a question first
              </Link>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
